// core/data/comments.ts — typed seed for post comments.
//
// Faithfully ported from legacy src/scripts/data/comments.js.
// Flatten rule: `parentId` always points to a top-level comment id (never to a
// nested comment). `replyingToHandle` provides visual attribution when the user
// replied to an already-nested comment.
//
// Legacy editHistory entries were plain `{ body, editedAt }` objects. The model
// uses `CommentEdit` which has the same fields — they are compatible at runtime.

import type { Comment } from '@/core/models/comment';

export const seedComments: Comment[] = [
  { id: 'c-001', postId: 'post-001', authorId: 'liberty-mind',
    parentId: null, replyingToHandle: null,
    body: 'This hits hard. The truth always finds a way.',
    time: '1h', likes: 24, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-002', postId: 'post-001', authorId: 'open-mind',
    parentId: null, replyingToHandle: null,
    body: "Couldn't agree more. Sunlight is the best disinfectant.",
    time: '45m', likes: 12, liked: true,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-003', postId: 'post-001', authorId: 'freedom-seeker',
    parentId: null, replyingToHandle: null,
    body: 'Saying it plainly is the rarest skill in the room.',
    time: '38m', likes: 9, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-004', postId: 'post-001', authorId: 'wayne-tech',
    parentId: null, replyingToHandle: null,
    body: 'Thanks all. Building forward.',
    time: '12m', likes: 18, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-005', postId: 'post-001', authorId: 'liberty-mind',
    parentId: null, replyingToHandle: null,
    body: 'Bookmarked, going back to this one.',
    time: '4m', likes: 3, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-006', postId: 'post-002', authorId: 'wayne-tech',
    parentId: null, replyingToHandle: null,
    body: 'A mind that opens to a new idea never returns to its original size.',
    time: '2h', likes: 7, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-007', postId: 'post-003', authorId: 'liberty-mind',
    parentId: null, replyingToHandle: null,
    body: 'I changed my mind about caffeine. Twice. Per day.',
    time: '5h', likes: 14, liked: true,
    deleted: false, edited: false, editHistory: [] },

  // Nested replies under post-001 (demonstrate depth-1 flatten)
  { id: 'c-101', postId: 'post-001', authorId: 'open-mind',
    parentId: 'c-001', replyingToHandle: null,
    body: 'Right? The signal is in what stays unchanged.',
    time: '50m', likes: 5, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-102', postId: 'post-001', authorId: 'freedom-seeker',
    parentId: 'c-001', replyingToHandle: '@OpenMindX',
    body: 'Exactly. And the signal hardens over time when it survives challenge.',
    time: '42m', likes: 3, liked: false,
    deleted: false, edited: false, editHistory: [] },

  // Profile Replies-tab seeds
  { id: 'c-012', postId: 'post-001', authorId: 'open-mind',
    parentId: 'c-004', replyingToHandle: '@WayneTech',
    body: 'Keep going. This thread aged well.',
    time: '8m', likes: 4, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-013', postId: 'post-002', authorId: 'liberty-mind',
    parentId: 'c-006', replyingToHandle: '@WayneTech',
    body: 'Stealing this quote, with attribution.',
    time: '1h', likes: 6, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-014', postId: 'post-009', authorId: 'freedom-seeker',
    parentId: null, replyingToHandle: null,
    body: 'Clean build. Respect.',
    time: '30m', likes: 5, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-015', postId: 'post-011', authorId: 'maya-patel',
    parentId: null, replyingToHandle: null,
    body: 'Volunteers and coffee: the real stack.',
    time: '2h', likes: 8, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-016', postId: 'post-005', authorId: 'jordan-lee',
    parentId: null, replyingToHandle: null,
    body: 'Decentralization is a maintenance burden worth carrying.',
    time: '3h', likes: 11, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-017', postId: 'post-004', authorId: 'wayne-tech',
    parentId: null, replyingToHandle: null,
    body: 'Foundations first. Everything else follows.',
    time: '20m', likes: 9, liked: false,
    deleted: false, edited: false, editHistory: [] },

  { id: 'c-018', postId: 'post-011', authorId: 'wayne-tech',
    parentId: null, replyingToHandle: null,
    body: 'Funding open source is funding the commons.',
    time: '5h', likes: 15, liked: false,
    deleted: false, edited: false, editHistory: [] },
];
